import Request from '../modules/XMLHttpRequest';

class PublicationPage {

    constructor() {
        this.publicationPage = document.querySelector('[data-js="publication-page"]');

        if (this.publicationPage) {
            //Variables
            this.cardDeckObj = this.publicationPage.querySelector('[data-js="card-deck"]');
            this.paginationObj = document.getElementById('pagination');

            this.pages = 0;
            this.pageId = this.paginationObj.getAttribute('data-pageid');
            this.pageNumber = 1;
            this.categoryId = 0;
            this.language = document.documentElement.lang;
            this.maxVisible = 10;
            this.viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            this.breakpoints = {
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1260
            }

            if (this.viewportWidth < this.breakpoints.md) {
                this.maxVisible = 5;
            }
            if (this.viewportWidth < this.breakpoints.sm) {
                this.maxVisible = 3;
            }

            //Functions
            this.tabsInteraction();
            this.paginationInteraction();
            this.initPage();
        }
    }

    /**
     * Initialize the page
     */
    initPage() {
        let hashtag = location.hash,
            request = new Request(),
            tabs = [...this.publicationPage.querySelectorAll('[data="filter-link"]')];

        // An overview with no publications renders no category tabs at all: the controller only
        // builds the category list inside `if (vm.HasResults)`, so the view's `@if
        // (Model.HasCategories)` omits the whole tabs-filter nav. There is no tab to activate, and
        // reading tabs[0] would throw — which, since `new PublicationPage()` is a top-level
        // statement in app.js, would abort the rest of the bundle and leave the mobile nav burger
        // unbound (#991).
        if (!tabs.length) {
            return;
        }

        if (hashtag === '') {
            hashtag = tabs[0].getAttribute('href');
        }

        tabs.map(tab => (tab.getAttribute('href') === hashtag) ? tab.click() : '');
    }

    /**
     * Initialize the pagnination
     */
    paginationInit(pages) {
        let request = new Request(),
            $this = this;

        // render pagination
        $.fn.pagination = function (pages) {
            if (pages > 1 && pages < $this.maxVisible) {
                $('#pagination').bootpag({
                    total: pages,
                    maxVisible: pages,
                    wrapClass: 'pagination justify-content-center',
                    next: ' ',
                    prev: ' ',
                    nextClass: 'hidden',
                    prevClass: 'hidden',
                    page: 1,
                    firstLastUse: false,
                });
            } else if (pages > 1) {
                $('#pagination').bootpag({
                    total: pages,
                    maxVisible: $this.maxVisible,
                    wrapClass: 'pagination justify-content-center',
                    next: '. . .',
                    prev: '. . .',
                    page: 1,
                    firstLastUse: true,
                    first: '',
                    last: ''
                });
            } else {
                $('#pagination ul').remove();
            }
        };

        $.fn.pagination(pages);
    }

    /**
    * Set pagination interaction
    */
    paginationInteraction() {
        let request = new Request(),
            $this = this;

        // Update list on pagination click
        $.fn.paginationClick = function () {
            $('#pagination').unbind('page').bootpag().on('page', function (event, pageNumber) {
                $this.categoryId = document.querySelector('[data="filter-link"].active').getAttribute('data-categoryid');
                $this.pageNumber = pageNumber;
                //(Init pagination)
                $this.getContent(false);
            });
        };

        // initiate pagination listener
        $.fn.paginationClick();
    }

    /**
     * Set tab interaction
     */
    tabsInteraction() {
        let tabs = this.publicationPage.querySelectorAll('[data="filter-link"]');
        [...tabs].forEach(tabs => tabs.addEventListener('click', (e) => this.getTabContent(e)));
    }

    /**
     * Get page content after tab interaction
     */
    getTabContent(e) {
        let activeTab = this.publicationPage.querySelector('[data="filter-link"].active');

        if (activeTab !== null) {
            $(activeTab).removeClass('active');
        }
        
        this.pageNumber = 1;
        e.target.className += ' active';
        this.categoryId = e.target.getAttribute('data-categoryId');
        this.getContent(true);
    }

    /**
    * Get content
    */
    getContent(initPagination) {
        let $this = this,
            request = new Request();

        request.get(`/api/publications/getpublications/${this.pageId}/${this.categoryId}/${this.pageNumber}/${this.language}`).then(function (response) {
            const payload = JSON.parse(response);
            const html = payload.html ?? payload.Html ?? '';
            const pages = payload.pages ?? payload.Pages ?? 0;

            $this.cardDeckObj.className += ' hide';
            $this.cardDeckObj.innerHTML = html;
            window.scrollTo(0,  0);
            if (initPagination) {
                $this.paginationInit(pages);
            }

            setTimeout(() => $($this.cardDeckObj).removeClass('hide'), 50);
        }, function (error) {
            console.error("Failed!", error);
        });  
    }
}

export default PublicationPage;